import { render, staticRenderFns } from "./EditMediaModal.vue?vue&type=template&id=20a0e4ca"
import script from "./EditMediaModal.vue?vue&type=script&lang=js"
export * from "./EditMediaModal.vue?vue&type=script&lang=js"
import style0 from "./EditMediaModal.vue?vue&type=style&index=0&id=20a0e4ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports